import React from 'react';

import { Layout } from '@neptune/shared/venus-ui';

type ProjectViewProps = {
  header: React.ReactNode;
  scene: React.ReactNode;
};

export const ProjectView: React.FC<ProjectViewProps> = ({ header, scene }) => {
  return (
    <Layout.Column className="project-view" overflow="hidden">
      {header}
      {scene}
    </Layout.Column>
  );
};
